import { FacebookLogo, InstagramLogo, WhatsappLogo, ArrowUpRight } from "@phosphor-icons/react";
import { motion } from "framer-motion";
import { SOCIALS, WHATSAPP } from "../data";

const BTNS = [
  { label: "Follow on Facebook", handle: "DS Cabs & Delivery", Icon: FacebookLogo, href: SOCIALS.facebook, bg: "bg-[#1877F2]", tid: "follow-facebook" },
  { label: "Follow on Instagram", handle: "@ds_cabs_", Icon: InstagramLogo, href: SOCIALS.instagram, bg: "bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF]", tid: "follow-instagram" },
  { label: "Message on WhatsApp", handle: "(902) 999-9066", Icon: WhatsappLogo, href: `https://wa.me/${WHATSAPP}`, bg: "bg-[#25D366]", tid: "follow-whatsapp" },
];

export const FollowUs = () => (
  <section id="follow" data-testid="follow-section" className="py-20 sm:py-28 bg-ink text-white">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-sun mb-3">Stay connected</p>
      <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] max-w-2xl">
        Follow the <span className="text-sun">ride.</span>
      </h2>
      <p className="mt-4 text-white/60 max-w-xl leading-relaxed">
        See our latest rides, deliveries and community moments — and reach us in one tap.
      </p>

      <div className="mt-10 grid sm:grid-cols-3 gap-4">
        {BTNS.map((b, i) => (
          <motion.a
            key={b.tid}
            href={b.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={b.tid}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className={`group ${b.bg} text-white p-6 border-2 border-white/10 flex items-center justify-between hover:-translate-y-1 transition-transform duration-200`}
          >
            <div className="flex items-center gap-4">
              <b.Icon weight="fill" size={34} />
              <div>
                <p className="font-display font-bold text-lg leading-tight">{b.label}</p>
                <p className="text-sm text-white/80">{b.handle}</p>
              </div>
            </div>
            <ArrowUpRight weight="bold" size={22} className="opacity-70 group-hover:opacity-100 transition-opacity" />
          </motion.a>
        ))}
      </div>
    </div>
  </section>
);
